export const labProducts = [
  {
    id: 'LAB-01',
    name: 'SupportFlow AI',
    category: 'Customer Operations',
    status: 'Production',
    summary:
      'Omnichannel intake, auto-triage, and policy-grounded response generation with human approval lanes.',
    impact: '42% faster first-response time',
    readiness: ['SLA monitoring', 'Audit logs', 'Role-based controls'],
  },
  {
    id: 'LAB-02',
    name: 'Revenue Signals',
    category: 'Sales Intelligence',
    status: 'Production',
    summary:
      'Pipeline-risk scoring and next-best-action recommendations connected to CRM and outreach workflows.',
    impact: '28% increase in qualified pipeline conversion',
    readiness: ['CRM integrations', 'Model evaluation', 'Alerting system'],
  },
  {
    id: 'LAB-03',
    name: 'ClaimAssist',
    category: 'Insurance Operations',
    status: 'Production',
    summary:
      'Claim document extraction, adjudication support, and exception routing for high-volume service teams.',
    impact: '61% reduction in manual processing time',
    readiness: ['Compliance workflows', 'PII safeguards', 'Traceable decisions'],
  },
  {
    id: 'LAB-04',
    name: 'HireLoop',
    category: 'Talent Acquisition',
    status: 'Scaled Pilot',
    summary:
      'Candidate screening and interview orchestration with recruiter-in-the-loop quality checkpoints.',
    impact: '2.1x faster shortlist delivery',
    readiness: ['ATS integrations', 'Bias checks', 'Approval workflows'],
  },
  {
    id: 'LAB-05',
    name: 'OpsCopilot',
    category: 'Internal Productivity',
    status: 'Production',
    summary:
      'Cross-system copilot for internal teams to execute SOPs, summarize tasks, and resolve workflow blockers.',
    impact: '33% lower cycle time in back-office queues',
    readiness: ['Knowledge indexing', 'Action APIs', 'Usage analytics'],
  },
  {
    id: 'LAB-06',
    name: 'RiskGuard',
    category: 'Governance and Security',
    status: 'Enterprise Rollout',
    summary:
      'Policy-aware guardrails and runtime checks that enforce security, privacy, and response-quality controls.',
    impact: '95% reduction in policy-violating outputs',
    readiness: ['Runtime guardrails', 'Red-team testing', 'Incident playbooks'],
  },
];

export const labCapacity = [
  {
    title: 'End-to-End Delivery',
    detail:
      'From use-case discovery to production rollout, the Lab operates full-stack across design, model strategy, engineering, and adoption.',
  },
  {
    title: 'Industry-Ready Architecture',
    detail:
      'Every application is built with observability, access controls, fallback logic, and governance controls required for enterprise use.',
  },
  {
    title: 'Integration-First Build Model',
    detail:
      'The Lab ships applications into real operating environments through CRM, ERP, support, document, and communication system integrations.',
  },
  {
    title: 'Scale and Reliability Operations',
    detail:
      'Post-launch support includes evaluation pipelines, reliability monitoring, and iteration cycles to maintain outcomes in production.',
  },
];

export const labStats = [
  { value: '25+', label: 'Industry applications launched' },
  { value: '150+', label: 'Enterprise integrations delivered' },
  { value: '99.9%', label: 'Monitored workflow uptime targets' },
  { value: '4-10 weeks', label: 'Typical build-to-launch windows' },
];
